<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden mt-4">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">
            <component :is="scrollbarTag" class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl">
                <!-- ACTIVE CHATS LIST -->
                <div class="chat__chats-list">
                    <div class="flex justify-content-between items-center">
                      <h3 class="text-primary mb-4 px-4">Live Chat</h3>
                      <vs-button type="filled" color="dark" icon="undo" size="small mb-4 mr-4 ml-2" @click="$router.push(`/event/chatgroups`)">Back
                      </vs-button>
                      <vs-button type="border" radius icon="add" size="small mb-4 mr-4 ml-auto" @click="$router.push(`/event/addchatgroup`)">
                      </vs-button>
                      <feather-icon icon="SettingsIcon" class="cursor-pointer mb-4 mr-4 ml-2" @click="getDefaultSettings" />
                    </div>
                    <ul class="chat__active-chats bordered-items" id="rooms-container">
                        <li class="cursor-pointer" :id="contact.id" v-for="(contact, index) in chatContacts" :key="index" @click="setActiveGroup(contact)">
                            <chat-contact showLastMsg :contact="contact" :lastMessaged="chatLastMessaged(contact.id).time" :unseenMsg="chatUnseenMessages(contact.id)" :isActiveChatUser="isActiveChatUser(contact.id)"></chat-contact>
                        </li>
                    </ul>
                </div>
            </component>
        </vs-sidebar>

        <!-- RIGHT COLUMN -->
        <div class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose, 'flex items-center justify-center': activeChatUser === null}">
            <template v-if="activeChatUser">
                <div class="chat__navbar">
                    <chat-navbar @targetLanguageSet="targetLanguageSet" :isSidebarCollapsed="!clickNotClose" :userId="activeChatUser" :chatGroup="activeGroup" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned" @openSponsoredPost="openSponsoredPost"></chat-navbar>
                </div>
                <component :is="scrollbarTag" class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl">
                    <div class="chat__log" ref="chatLog">
                        <chat-log :roomId="activeChatUser" v-if="activeChatUser" :key="componentKey"></chat-log>
                    </div>
                </component>
                <div class="chat__input flex p-4 bg-white">
                    <input class="hidden" ref="update_avatar_input" type="file" @change="update_avatar($event, '200x100', 'UserIcon', 'userIcon', true)" accept="image/*" />
                    <vs-avatar class="shadow border-solid border-white m-0" :src="userIcon" @click="$refs.update_avatar_input.click()"></vs-avatar>
                    <vs-input placeholder="User Name" class="flex-0 ml-4" v-model="userName" />
                    <vs-input class="flex-1 ml-4" placeholder="Type Your Message" v-model="typedMessage" @keyup.enter="sendMsg" />
                    <vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMsg">Send</vs-button>
                </div>
            </template>
            <template v-else>
                <div class="flex flex-col items-center">                    
                    <feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
                    <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" @click.stop="toggleChatSidebar(true)">Start Conversation</h4>
                </div>
            </template>
        </div>
        <div v-if="popupActive2 == true">
          <advance-settings :data="popupActive2" :key="SettingsResetKey" v-on:saveSettingsData="saveSettingsData"/>
        </div>
        <vs-popup
          class="holamundo registrationType-popup"
          title="Crop Image"
          :active.sync="popupCropper"
          fullscreen="fullscreen"
          v-if="cropImageUrl"
        >
          <h5>
            Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
            image, simply drag and click Upload
          </h5>
          <photowall-resize-component
            :key="resetCropper"
            v-bind:aspectValue="imageRatio"
            :sourceImage="cropImageUrl"
            @croppedImagePath="croppedImagePath"
          />
        </vs-popup>
        <vs-popup
          class="holamundo sponsor-chat-message"
          title="Sponsored Message"
          :active.sync="sponsoredPostPopup"
        >
          <div class="vx-row">            
            <div class="vx-col md:w-12/12 w-full">
              <img
                v-show="sponsoredMsgImgUrl"
                :src="sponsoredMsgImgUrl"
                class="mr-8 rounded h-10 w-10"
              />
              <vs-input
                label="Image"
                type="file"
                accept="image/*"
                @change="update_avatar($event,'600x300', 'MessageImages', 'sponsoredMsgImgUrl', true)"
              />
            </div>
            <div class="vx-col md:w-12/12 w-full">
              <vs-input
                class="w-full"
                label="Message"
                v-model="sponsored_message.msgText"
              />
            </div>
            <div class="vx-col md:w-12/12 w-full">
              <vs-input
                class="w-full"
                label="User Name"
                v-model="sponsored_message.senderDisplayName"
              />
            </div>
            <div class="vx-col md:w-12/12 w-full">
              <div class="flex flex-wrap items-center justify-end mt-4"> 
                <!-- <vs-checkbox v-model="sponsored_message.PostNow" class="w-full">Post Now or repeat post after</vs-checkbox>  -->
                <vs-avatar class="shadow border-solid border-white w-10 h-10" :src="userIcon" @click="$refs.update_avatar_input.click()"></vs-avatar>
                <span class="ml-4">
                  <label>Broadcast Threshold</label>
                  <vs-input-number                    
                    min="1"
                    v-model="sponsored_message.broadcastThreshold"
                  />
                </span>
                
                <vs-button
                  class="ml-auto"
                  type="filled"
                  @click="sendBroadcastMessage"
                  >Save</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-popup
      class="holamundo userlist-popup"
      title="Sponsored Posts"
      :active.sync="sponsoredPostListPopup"
    >
      <div
        class="
          vx-col
          flex
          justify-content-between
          align-items-center
          w-full
          text-right
          mb-5
          event-admin-popup-header
        "
      >
        <vs-button class="ml-2" @click="openSponsoredPostMessage">Add New</vs-button>        
      </div>
      <div class="flex flex-wrap">
        <div class="flex-grow">
          <div>
            <vs-table :data="broadcastMessageList">
              <template slot="thead">
                <vs-th>Message</vs-th>
                <vs-th>Message Image</vs-th>
                <vs-th>Thresold</vs-th>
                <vs-th>Sender Name</vs-th>
                <vs-th>Sender Image</vs-th>
                <vs-th>Sent On</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].id">{{
                    data[indextr].msgText
                  }}</vs-td>
                  <vs-td :data="data[indextr].id">
                    <vs-avatar :src="data[indextr].msgImgUrl" class="flex-shrink-0 mr-2" size="30px" />
                  </vs-td>
                  <vs-td :data="data[indextr].id">{{
                    data[indextr].broadcastThreshold
                  }}</vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].senderDisplayName}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <vs-avatar :src="data[indextr].senderAvatarUrl" class="flex-shrink-0 mr-2" size="30px" />
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].sentAtDtm | moment }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-popup>
    </div>
</template>

<script>
import ChatContact         from './ChatContact.vue'
import ChatLog             from './ChatLog.vue'
import ChatNavbar          from './ChatNavbar.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleChat          from '@/store/chat/moduleChat.js'
import AdvanceSettings from "./AdvanceSettings.vue";

import moment from "moment-timezone";
import moduleChatgroupManagement from "@/store/chatgroup-management/moduleChatgroupManagement.js";
import ls from "@/common/localStorage";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
var cn = ls.getSessionEventCollectionName();
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
export default {
  data () {
    return {
      active               : true,
      isHidden             : false,
      searchContact        : '',
      activeProfileSidebar : false,
      activeChatUser       : null,
      userProfileId        : -1,
      typedMessage         : null,
      isChatPinned         : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.70
      },
      clickNotClose        : true,
      isChatSidebarActive  : true,
      isLoggedInUserProfileView: false,

      activeGroup: null,
      componentKey: 0,
      popupActive2: false,
      SettingsResetKey: 0,
      targetLanguage: "en",
      userIcon: ls.getSessionValueByKey('ProfilePictureURL'),
      userName: ls.getSessionValueByKey('ClientName'),
      imageRatio: 1 / 1,
      cropImageUrl: null,
      popupCropper: false,
      resetCropper: 0,
      displayImageRatio: "1 / 1",
      uploadedFile: null,
      uploadedFolder: null,
      uploadedImgSrc: null,
      sponsoredMsgImgUrl: null,
      sponsoredPostPopup: false,
      sponsored_message:  {
        roomIdList: [],
        senderDisplayName: ls.getSessionValueByKey('ClientName'),
        msgText: null,
        //PostNow: false,
        broadcastThreshold: 15,
        msgImgUrl: null,
        senderAvatarUrl: ls.getSessionValueByKey('ProfilePictureURL')
      },
      broadcastMessageList: [],
      sponsoredPostListPopup: false
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  filters: {
    moment: function (date) {
      return moment(new Date(date.seconds * 1000)).tz(Session_Event_TZ).format('MM/DD/YYYY, h:mm A');
    }
  },
  computed: {
    chatLastMessaged () {
      return (userId) => this.$store.getters['chat/chatLastMessaged'](userId)
    },
    chatUnseenMessages () {
      return (userId) => {
        const unseenMsg = this.$store.getters['chat/chatUnseenMessages'](userId)
        if (unseenMsg) return unseenMsg
      }
    },
    activeUser () {
      return this.$store.state.AppActiveUser
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    },
    chatContacts () {
      return this.$store.state.chatgroupManagement.chatgroups;
    },
    contacts () {
      return this.$store.getters['chat/contacts']
    },
    searchQuery: {
      get () {
        return this.$store.state.chat.chatSearchQuery
      },
      set (val) {
        this.$store.dispatch('chat/setChatSearchQuery', val)
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    isActiveChatUser () {
      return (userId) => userId === this.activeChatUser
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    sendBroadcastMessage(){      
      this.$vs.loading();
      this.sponsored_message.roomIdList = [this.activeGroup.id];
      this.sponsored_message.senderAvatarUrl = this.userIcon;
      this.sponsored_message.msgImgUrl = this.sponsoredMsgImgUrl;
      this.$store.dispatch('chatgroupManagement/sendBroadcastMessage', this.sponsored_message).then(res=>{
        this.$vs.loading.close();
        this.sponsoredPostPopup = false;
      }).catch(err=>{ this.$vs.loading.close(); })
    },
    getUserStatus (isActiveUser) {
      // return "active"
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.contacts[this.activeChatUser].status
    },
    closeProfileSidebar (value) {
      this.activeProfileSidebar = value
    },
    updateActiveChatUser (id) {
      /*this.activeChatUser = id
      if (this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)) {
        this.$store.dispatch('chat/markSeenAllMessages', contactId)
      }
      const chatData = this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)
      if (chatData) this.isChatPinned = chatData.isPinned
      else this.isChatPinned = false
      this.toggleChatSidebar()
      this.typedMessage = ''*/
      

    },
    setActiveGroup(group){
      //this.$vs.loading();
      this.$store.dispatch('chatgroupManagement/clearChatGroupMessages');
      this.$store.dispatch('chatgroupManagement/listenChatGroupMessages', {roomId:group.id, language:this.targetLanguage});
      //this.$store.dispatch('chatgroupManagement/getChatGroupMessages', group.id).then(res=>{
        //this.$vs.loading.close();
        this.activeChatUser = group.id
        this.activeGroup = group;
        //const chatData = res
        this.isChatPinned = false
        this.componentKey += 1;
        this.toggleChatSidebar();
      //}).catch(err=>{ this.$vs.loading.close(); })
    },
    showProfileSidebar (userId, openOnLeft = false) {
      this.userProfileId = userId
      this.isLoggedInUserProfileView = openOnLeft
      this.activeProfileSidebar = !this.activeProfileSidebar
    },
    sendMsg () {        
      if (this.typedMessage && this.userName){
        this.$vs.loading();      
        let payload = {
          "roomId": this.activeGroup.id,
          "msgType": "TEXT",
          "msgText": this.typedMessage,
          "fileUrl": null,
          "senderName": this.userName,
          "senderPhotoUrl": this.userIcon
        }
        this.$store.dispatch('chatgroupManagement/postChatMessage', payload).then(res=>{
          this.$vs.loading.close();
          this.typedMessage = null
        }).catch(err=>{ this.$vs.loading.close(); })
      }
      

      const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
      scroll_el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    toggleIsChatPinned (value) {
      this.isChatPinned = value
    },
    setSidebarWidth () {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    },
    saveSettingsData(){
      //this.popupActive2 = false;
    },
    getDefaultSettings() {
      this.SettingsResetKey += 1;
      this.popupActive2 = true;
    },
    targetLanguageSet(language){
      this.targetLanguage = language
      this.setActiveGroup(this.activeGroup)
    },
    croppedImagePath(blob) {
      //this.imgSrc = blob;
      this.popupCropper = false;
      if (this.uploadedFile)
        vm.uploadImage(blob, `${cn}/Chatgroup/${this.uploadedFolder}/`, this.uploadedFile);
    },
    update_avatar(input, fileWH, folderLocation, imgSrc, checkRatio = false) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        this.uploadedFolder = folderLocation;
        this.uploadedImgSrc = imgSrc;
        console.log(this.uploadedImgSrc)
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.popupCropper = true;
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("chatgroupManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.$data[this.uploadedImgSrc] = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    openSponsoredPost(){
      this.$vs.loading();
      this.$store.dispatch("chatgroupManagement/getBroadcastMessagesofGroup", this.activeGroup.id).then((res) => {
        this.$vs.loading.close();
        this.broadcastMessageList = res;
        this.sponsoredPostListPopup = true
      })
    },
    openSponsoredPostMessage(){
      this.sponsored_message =  {
        roomIdList: [this.activeGroup.id],
        senderDisplayName: ls.getSessionValueByKey('ClientName'),
        msgText: null,
        //PostNow: false,
        broadcastThreshold: 15,
        msgImgUrl: null,
        senderAvatarUrl: ls.getSessionValueByKey('ProfilePictureURL')
      }
      this.sponsoredPostListPopup = false
      this.sponsoredPostPopup = true
    }
  },
  components: {
    VuePerfectScrollbar,
    ChatContact,
    ChatNavbar,
    ChatLog,
    AdvanceSettings,
    PhotowallResizeComponent
  },
  created () {
    vm = this;
    this.$store.registerModule('chat', moduleChat)
    this.$store.dispatch('chat/fetchContacts')
    this.$store.dispatch('chat/fetchChatContacts')
    this.$store.dispatch('chat/fetchChats')
    this.setSidebarWidth()

    if (!moduleChatgroupManagement.isRegistered) {
      this.$store.registerModule("chatgroupManagement", moduleChatgroupManagement);
      moduleChatgroupManagement.isRegistered = true;
    }
    this.$store.dispatch("chatgroupManagement/fetchChatgroups");
  },
  beforeDestroy () {
    this.$store.unregisterModule('chat')
  },
  mounted () {
    this.$store.dispatch('chat/setChatSearchQuery', '')
    if(this.$route.params.roomObj){
      //console.log(this.$route.params.roomObj)
      this.setActiveGroup(this.$route.params.roomObj);  
    }
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
